<template>
  <div class="form_box">
    <div v-if="auditState === 0" class="fail_reason">
      <div class="fail_title">未通过原因</div>
      <div class="fail_desc" :title="(reason.length > 51)? reason : ''">{{reason}}</div>
    </div>
    <el-form class="info_form" size="mini" :model="formData" label-width="130px" ref="form">
      <el-form-item class="img_info" label="资质证件">
        <div class="doc_box">
          <p class="doc_title">1.请上传认证人身份证正反面</p>
          <UploadImage class="fl" :img-src.sync="formData.cardFrontUrl">
            身份证正面
            <span class="sub">(小于5M)</span>
          </UploadImage>
          <UploadImage class="fl mgl20" :img-src.sync="formData.cardBackUrl">
            身份证反面
            <span class="sub">(小于5M)</span>
          </UploadImage>
        </div>
        <span class="box_line"></span>
        <div class="doc_box">
          <p class="doc_title">2.请上传手持身份证照</p>
          <UploadImage :img-src.sync="formData.userCardUrl">
            手持身份证照
            <span class="sub">(小于5M)</span>
          </UploadImage>
        </div>
      </el-form-item>
      <el-form-item label="认证人姓名">
        <el-input
          placeholder="姓名需与身份证保持一致"
          maxlength="20"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="formData.customerName"
          @input="v => { formData.customerName = v.trim() }">
        </el-input>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input
          placeholder="请输入"
          maxlength="20"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="formData.contacter"
          @input="v => { formData.contacter = v.trim() }">
        </el-input>
      </el-form-item>
      <el-form-item label="联系人电话">
        <el-input
          placeholder="请输入"
          maxlength="16"
          suffix-icon="iconfont icon-biaodan-tianxie"
          v-model="formData.contactPhone"
          @input="inputPhone">
        </el-input>
      </el-form-item>
    </el-form>
    <ad-button class="save_btn" :width="210" :height="40" @click="saveInfo">
      {{auditState === -2 ? '提交审核' : '重新提交审核'}}
    </ad-button>
  </div>
</template>

<script>
import firmPerson from '../mixin/firmperson'

export default {
  name: 'FormPerson',
  mixins: [ firmPerson ],
  data () {
    return {
      adType: 1,
      formData: {
        advertiserType: 1,
        cardFrontUrl: '',
        cardBackUrl: '',
        userCardUrl: '',
        customerName: '',
        contacter: '',
        contactPhone: ''
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../style/firmPerson'
</style>
